export function getBlankRecord() {
  return {
    type: null,
    lowerBound: null,
    score: null,
    customLabel: null
  };
}
